<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link
          href="/"
          class="brand-logo"
        >
          <b-img
            :src="appLogoImage"
            alt="logo"
          />
        </b-link>

        <b-card-title class="mb-1">
          {{ $t('WelcomeMessageLogin') }}
        </b-card-title>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              :label="$t('Email')"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="signInEmail"
                  name="signin-email"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">{{ $t('Password') }}</label>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small
                  v-if="errors.length"
                  class="text-danger"
                >{{ errors[0] }}<br></small>
                <b-link
                  :to="{ name: 'auth-forgot-password' }"
                  class="underlined-textlink"
                >
                  <small style="font-size: 13px;">{{ $t('Forgot Password?') }}</small>
                </b-link>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <!-- <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="rememberMe"
                name="checkbox-1"
              >
                {{ $t('Remember me') }}
              </b-form-checkbox>
            </b-form-group> -->

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="submitLoginData"
            >
              {{ $t('SignIn') }}
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span style="font-size: 14px;">{{ $t("You do not have an account?") }}</span>
        </b-card-text>

        <b-card-text
          class="text-center"
          style="font-size: 14px;"
        >
          <b-link
            :to="{ name: 'mentor-register' }"
            class="underlined-textlink"
          >
            {{ $t("BecomeMentor") }}
          </b-link>
          {{ $t("or") }}
          <b-link
            :to="{ name: 'mentee-register' }"
            class="underlined-textlink"
          >
            {{ $t("BecomeMentee") }}
          </b-link>
        </b-card-text>

        <!-- <div class="divider my-2">
          <div class="divider-text">
            or
          </div>
        </div> -->

        <!-- social button -->
        <!-- <div class="auth-footer-btn d-flex justify-content-center">
          <b-button
            href="javascript:void(0)"
            variant="facebook"
          >
            <feather-icon icon="FacebookIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="twitter"
          >
            <feather-icon icon="TwitterIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="google"
          >
            <feather-icon icon="MailIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="github"
          >
            <feather-icon icon="GithubIcon" />
          </b-button>
        </div> -->
      </b-card>
      <!-- /Login v1 -->
      <choose-account-modal />
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BImg, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { required, email } from '@mentoring-platform-validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { $themeConfig } from '@themeConfig'
import LoginMixin from '@mentoring-platform/mixins/LoginMixin'
import ChooseAccountModal from '@mentoring-platform/views/components/blocks/ChooseAccountModal.vue'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,

    ChooseAccountModal,
  },
  mixins: [
    togglePasswordVisibility,
    LoginMixin,
  ],
  data() {
    return {
      userEmail: '',
      password: '',
      rememberMe: '',
      // validation rules
      required,
      email,
    }
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app

    return {
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';

.brand-logo {
  img {
    width: 220px;
  }
}
</style>
